import { render } from "./Columns.vue?vue&type=template&id=d28a3a24"
import script from "./Columns.vue?vue&type=script&lang=js"
export * from "./Columns.vue?vue&type=script&lang=js"

import "./Columns.vue?vue&type=style&index=0&id=d28a3a24&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__